import PostsFilter from './PostsFilter';

export default PostsFilter;
